import React from 'react';
import PropTypes from 'prop-types';

import manuscriptImg from '@assets/svg/assets/manuscript.svg';
import noDataImg from '@assets/svg/assets/no-data.svg';

import './HistoryEmptyState.scss';

function getAriaLabel(isFiltered, page, isAnonymousNoData = false) {
  if (isFiltered) return 'No results found';
  if (page === 'saved') {
    return isAnonymousNoData ? 'Sign in to see your saved searches' : 'No saved searches available';
  }
  return 'No recent searches available';
}

function getTitle(isFiltered, isAnonymousNoData, page) {
  if (isFiltered) return 'No results';
  if (isAnonymousNoData) return 'No Saved Searches';
  return `No ${page} searches`;
}

function getMessage(isFiltered, isAnonymousNoData) {
  if (isFiltered) {
    return 'Check your spelling or try another keyword. If you expected to see results, we welcome your feedback.';
  }
  if (isAnonymousNoData) {
    return 'Sign in to see your saved searches';
  }
  return null;
}

function HistoryEmptyState({ page, source, isAnonymous }) {
  const isFiltered = source === 'filtered';
  const isAnonymousNoData = isAnonymous && !isFiltered && page === 'saved';

  const ariaLabel = getAriaLabel(isFiltered, page, isAnonymousNoData);
  const title = getTitle(isFiltered, isAnonymousNoData, page);
  const message = getMessage(isFiltered, isAnonymousNoData);

  return (
    <div className="history-empty-state" aria-live="polite" aria-label={ariaLabel}>
      <img
        className="history-empty-state__image"
        src={isAnonymousNoData ? manuscriptImg : noDataImg}
        alt="noresults-image"
        aria-hidden="true"
        data-testid={isAnonymousNoData ? 'history-empty-state-manuscript-image' : 'history-empty-state-no-data-image'}
      />
      <h2 className="u-els-margin-top u-els-font-size-h3 u-els-text-center">{title}</h2>
      {message && <p className="u-els-text-center">{message}</p>}
    </div>
  );
}

HistoryEmptyState.propTypes = {
  page: PropTypes.string.isRequired,
  source: PropTypes.string,
  isAnonymous: PropTypes.bool,
};

export default HistoryEmptyState;
